import { useEffect, useState } from "react";
import { Tabs } from "antd";
import { useLocation } from "react-router-dom";
import { Can } from "@/shared/lib/casl";
import { useCoordinator } from "@shared/lib/hooks/";
import { useNavigate, useAppRoutes } from "@shared/lib/react-router";
import "./project-tabs.scss";

export const ProjectTabs = () => {
  const navigate = useNavigate();
  const routes = useAppRoutes();
  const { projectId } = useCoordinator();
  const location = useLocation();

  const [activeKey, setActiveKey] = useState<string>();

  useEffect(() => {
    setActiveKey(location.pathname);
  }, [location.pathname]);

  const onTabChange = (key: string) => {
    navigate(key);
  };

  const baseTabs = [
    { key: routes.general.root(projectId || ""), label: "Общая информация" },
    { key: routes.general.members(projectId || ""), label: "Участники" },
    { key: routes.objects.root(projectId || ""), label: "Объекты строительства" },
    // { key: routes.general.related(projectId), label: "Связанные данные" },
    // { key: routes.general.history(projectId), label: "История" },
  ];

  const settingsTab = { key: routes.general.settings(projectId || ""), label: "Настройки" };

  return (
    <>
    <Can I="edit" a="project">
        <Tabs
          items={[...baseTabs, settingsTab]}
          className="project-custom-tabs"
          activeKey={activeKey}
          onChange={onTabChange}
          tabBarStyle={{ overflow: "hidden" }}
          tabBarGutter={32}
          style={{ marginBottom: "32px" }}
        />

    </Can>
    <Can not I="edit" a="project">
      <Tabs
        items={baseTabs}
        className="project-custom-tabs"
        activeKey={activeKey}
        onChange={onTabChange}
        tabBarStyle={{ overflow: "hidden" }}
        tabBarGutter={32}
        style={{ marginBottom: "32px" }}
      />
    </Can></>

  );
};
